// extracted by mini-css-extract-plugin
export default {"root":"gift_card_buy_store_page_layout_root__T8usl","giftCardStoreContent":"gift_card_buy_store_page_layout_giftCardStoreContent__8t106"};